function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M46.7795 21.4651C43.7664 21.4651 41.313 18.9081 41.313 15.7636C41.313 12.6192 43.7664 10.0622 46.7795 10.0622H47.1182C47.4706 10.0622 47.754 10.3455 47.754 10.698C47.754 11.0504 47.4706 11.3338 47.1182 11.3338H46.7795C44.4713 11.3338 42.5846 13.3172 42.5846 15.7567C42.5846 18.1963 44.4644 20.1797 46.7795 20.1797C49.0878 20.1797 50.9744 18.1963 50.9744 15.7567V0.635798C50.9744 0.283345 51.2578 0 51.6102 0C51.9627 0 52.246 0.283345 52.246 0.635798V15.7636C52.246 18.9081 49.7927 21.4651 46.7795 21.4651Z",
  fill: "inherit",
  stroke: "none"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M67.0073 30.0001H61.0018C60.6493 30.0001 60.366 29.7167 60.366 29.3643C60.366 29.0118 60.6493 28.7285 61.0018 28.7285H67.0073C68.6451 28.7285 69.972 27.3878 69.972 25.743V15.7706C69.972 13.3311 68.0923 11.3477 65.7771 11.3477C63.4689 11.3477 61.5823 13.3311 61.5823 15.7706C61.5823 18.2101 63.462 20.1936 65.7771 20.1936H66.1158C66.4682 20.1936 66.7516 20.4769 66.7516 20.8294C66.7516 21.1818 66.4682 21.4652 66.1158 21.4652H65.7771C62.764 21.4652 60.3107 18.9081 60.3107 15.7637C60.3107 12.6193 62.764 10.0623 65.7771 10.0623C68.7903 10.0623 71.2436 12.6193 71.2436 15.7637V25.7291C71.2505 28.0858 69.35 30.0001 67.0073 30.0001Z",
  fill: "inherit",
  stroke: "none"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M94.1121 21.472H93.7735C90.7604 21.472 88.307 18.915 88.307 15.7705C88.307 12.6261 90.7604 10.0691 93.7735 10.0691C96.7866 10.0691 99.24 12.6261 99.24 15.7705V20.8293C99.24 21.1817 98.9566 21.4651 98.6042 21.4651C98.2517 21.4651 97.9684 21.1817 97.9684 20.8293V15.7705C97.9684 13.331 96.0886 11.3476 93.7735 11.3476C91.4584 11.3476 89.5786 13.331 89.5786 15.7705C89.5786 18.2101 91.4584 20.1935 93.7735 20.1935H94.1121C94.4646 20.1935 94.7479 20.4768 94.7479 20.8293C94.7479 21.1886 94.4646 21.472 94.1121 21.472Z",
  fill: "inherit",
  stroke: "none"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M56.2958 21.4652C55.9433 21.4652 55.66 21.1819 55.66 20.8294V10.6912C55.66 10.3388 55.9433 10.0554 56.2958 10.0554C56.6482 10.0554 56.9316 10.3388 56.9316 10.6912V20.8294C56.9316 21.1819 56.6482 21.4652 56.2958 21.4652Z",
  fill: "inherit",
  stroke: "none"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  d: "M56.2953 8.22422C56.7915 8.22422 57.1937 7.81889 57.1937 7.31889C57.1937 6.8189 56.7915 6.41357 56.2953 6.41357C55.7991 6.41357 55.3969 6.8189 55.3969 7.31889C55.3969 7.81889 55.7991 8.22422 56.2953 8.22422Z",
  fill: "inherit",
  stroke: "none"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  d: "M75.2796 21.4652C74.9272 21.4652 74.6438 21.1819 74.6438 20.8294V10.6912C74.6438 10.3388 74.9272 10.0554 75.2796 10.0554C75.6321 10.0554 75.9154 10.3388 75.9154 10.6912V20.8294C75.9154 21.1819 75.6321 21.4652 75.2796 21.4652Z",
  fill: "inherit",
  stroke: "none"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  d: "M84.8929 21.4651C81.8106 21.4651 79.302 18.9426 79.302 15.8465V0.684138C79.302 0.331685 79.5853 0.0483398 79.9378 0.0483398C80.2902 0.0483398 80.5736 0.331685 80.5736 0.684138V15.8465C80.5736 18.2377 82.5086 20.1866 84.8929 20.1866C85.2453 20.1866 85.5287 20.4699 85.5287 20.8224C85.5287 21.1817 85.2453 21.4651 84.8929 21.4651Z",
  fill: "inherit",
  stroke: "none"
});

var _ref9 =
/*#__PURE__*/
React.createElement("path", {
  d: "M107.926 21.4651C107.574 21.4651 107.291 21.1817 107.291 20.8293V0.684138C107.291 0.331685 107.574 0.0483398 107.926 0.0483398C108.279 0.0483398 108.562 0.331685 108.562 0.684138V20.8224C108.562 21.1817 108.279 21.4651 107.926 21.4651Z",
  fill: "inherit",
  stroke: "none"
});

var _ref10 =
/*#__PURE__*/
React.createElement("path", {
  d: "M103.261 21.4651C102.909 21.4651 102.626 21.1817 102.626 20.8293V0.684138C102.626 0.331685 102.909 0.0483398 103.261 0.0483398C103.614 0.0483398 103.897 0.331685 103.897 0.684138V20.8224C103.897 21.1817 103.614 21.4651 103.261 21.4651Z",
  fill: "inherit",
  stroke: "none"
});

var _ref11 =
/*#__PURE__*/
React.createElement("path", {
  d: "M75.2798 8.22422C75.7759 8.22422 76.1782 7.81889 76.1782 7.31889C76.1782 6.8189 75.7759 6.41357 75.2798 6.41357C74.7836 6.41357 74.3813 6.8189 74.3813 7.31889C74.3813 7.81889 74.7836 8.22422 75.2798 8.22422Z",
  fill: "inherit",
  stroke: "none"
});

var _ref12 =
/*#__PURE__*/
React.createElement("path", {
  d: "M84.8929 11.2648H79.9378C79.5853 11.2648 79.302 10.9814 79.302 10.629C79.302 10.2765 79.5853 9.99316 79.9378 9.99316H84.8929C85.2453 9.99316 85.5287 10.2765 85.5287 10.629C85.5287 10.9814 85.2453 11.2648 84.8929 11.2648Z",
  fill: "inherit",
  stroke: "none"
});

var _ref13 =
/*#__PURE__*/
React.createElement("path", {
  d: "M116.434 21.5342C116.268 21.5342 116.109 21.472 115.985 21.3476L110.864 16.199C110.615 15.9503 110.615 15.5425 110.864 15.2937L115.922 10.2073C116.171 9.95855 116.572 9.95855 116.821 10.2073C117.07 10.4561 117.07 10.8639 116.821 11.1127L112.211 15.7498L116.883 20.4423C117.132 20.6911 117.132 21.0988 116.883 21.3476C116.759 21.472 116.6 21.5342 116.434 21.5342Z",
  fill: "inherit",
  stroke: "none"
});

var _ref14 =
/*#__PURE__*/
React.createElement("path", {
  d: "M77.1525 25.6533L76.8 26.0196C76.5028 25.7363 76.2126 25.5911 75.9361 25.5911C75.7565 25.5911 75.6044 25.6533 75.4731 25.7708C75.3418 25.8883 75.2796 26.0265 75.2796 26.1855C75.2796 26.3237 75.3349 26.455 75.4386 26.5863C75.5422 26.7176 75.7634 26.8696 76.102 27.0424C76.5166 27.2567 76.7931 27.4571 76.9382 27.6575C77.0833 27.8579 77.1525 28.079 77.1525 28.3347C77.1525 28.6872 77.0281 28.9844 76.7793 29.2332C76.5305 29.475 76.2195 29.5994 75.8532 29.5994C75.6044 29.5994 75.3694 29.5441 75.1414 29.4405C74.9133 29.3299 74.7267 29.1848 74.5816 28.9982L74.9271 28.6043C75.2105 28.9222 75.5077 29.0811 75.8256 29.0811C76.0467 29.0811 76.2333 29.012 76.3923 28.8669C76.5512 28.7218 76.6272 28.5559 76.6272 28.3693C76.6272 28.2104 76.5788 28.0721 76.4752 27.9477C76.3715 27.8233 76.1435 27.6713 75.7772 27.4916C75.3902 27.2912 75.1276 27.0977 74.9893 26.8973C74.8511 26.7038 74.782 26.4826 74.782 26.2338C74.782 25.909 74.8926 25.6395 75.1137 25.4184C75.3349 25.2041 75.6182 25.0935 75.9569 25.0935C76.3577 25.0728 76.7516 25.2663 77.1525 25.6533Z",
  fill: "inherit",
  stroke: "none"
});

var _ref15 =
/*#__PURE__*/
React.createElement("path", {
  d: "M78.2931 25.1832H78.846V25.9226C79.0395 25.6462 79.233 25.4458 79.4403 25.3214C79.7167 25.1555 80.0139 25.0657 80.318 25.0657C80.5253 25.0657 80.7257 25.1071 80.9123 25.1901C81.0989 25.273 81.2509 25.3767 81.3684 25.5149C81.4859 25.6531 81.5896 25.8466 81.6794 26.0954C81.866 25.7568 82.0941 25.5011 82.3705 25.3283C82.6469 25.1555 82.9441 25.0657 83.262 25.0657C83.5592 25.0657 83.8218 25.1417 84.0498 25.2937C84.2779 25.4458 84.4437 25.6531 84.5543 25.9226C84.6649 26.1921 84.7202 26.593 84.7202 27.132V29.4748H84.1535V27.132C84.1535 26.669 84.1189 26.358 84.0567 26.1852C83.9945 26.0125 83.8771 25.8742 83.7181 25.7706C83.5592 25.6669 83.3726 25.6116 83.1514 25.6116C82.8819 25.6116 82.64 25.6876 82.4189 25.8466C82.1977 26.0055 82.0388 26.2129 81.9351 26.4755C81.8314 26.7381 81.7831 27.1804 81.7831 27.7955V29.4748H81.2302V27.2771C81.2302 26.7588 81.1956 26.4064 81.1334 26.2198C81.0712 26.0332 80.9538 25.8881 80.7948 25.7706C80.6359 25.66 80.4424 25.6047 80.2212 25.6047C79.9655 25.6047 79.7305 25.6807 79.5025 25.8328C79.2813 25.9848 79.1155 26.1921 79.0118 26.4548C78.9082 26.7174 78.8529 27.1113 78.8529 27.6503V29.4679H78.3V25.1832H78.2931Z",
  fill: "inherit",
  stroke: "none"
});

var _ref16 =
/*#__PURE__*/
React.createElement("path", {
  d: "M90.0413 25.1833V29.475H89.4953V28.7355C89.2673 29.0188 89.0046 29.2262 88.7144 29.3713C88.4241 29.5164 88.1131 29.5855 87.7676 29.5855C87.1594 29.5855 86.6411 29.3644 86.2127 28.9221C85.7842 28.4798 85.5699 27.9477 85.5699 27.3119C85.5699 26.6968 85.7842 26.1647 86.2196 25.7293C86.655 25.287 87.1733 25.0728 87.7883 25.0728C88.1408 25.0728 88.4587 25.1488 88.742 25.3008C89.0254 25.4529 89.2811 25.674 89.4953 25.9781V25.1902H90.0413V25.1833ZM87.8367 25.6049C87.5326 25.6049 87.2424 25.6809 86.9867 25.8329C86.7241 25.985 86.5167 26.1992 86.3647 26.4687C86.2127 26.7452 86.1366 27.0285 86.1366 27.3326C86.1366 27.6367 86.2127 27.9269 86.3716 28.1965C86.5237 28.4729 86.7379 28.6871 86.9936 28.8392C87.2562 28.9912 87.5326 29.0672 87.8367 29.0672C88.1408 29.0672 88.4241 28.9912 88.6937 28.8392C88.9632 28.6871 89.1705 28.4798 89.3156 28.2241C89.4608 27.9615 89.5368 27.6712 89.5368 27.3464C89.5368 26.8488 89.3709 26.4342 89.0461 26.1025C88.7144 25.7708 88.3136 25.6049 87.8367 25.6049Z",
  fill: "inherit",
  stroke: "none"
});

var _ref17 =
/*#__PURE__*/
React.createElement("path", {
  d: "M92.9438 25.0728C92.7433 25.0728 92.5498 25.135 92.3632 25.2593C92.1766 25.3837 91.997 25.5634 91.8311 25.8122V25.1833H91.2644V29.475H91.8311V28.0237C91.8311 27.2773 91.8657 26.7866 91.9348 26.5379C92.0246 26.22 92.1559 25.985 92.3287 25.8329C92.5015 25.6809 92.6742 25.6049 92.8608 25.6049C92.9368 25.6049 93.0198 25.6256 93.1303 25.6671C93.1442 25.674 93.158 25.6602 93.158 25.6533V25.1073C93.158 25.1004 93.1511 25.0935 93.1442 25.0866C93.0612 25.0797 92.999 25.0728 92.9438 25.0728Z",
  fill: "inherit",
  stroke: "none"
});

var _ref18 =
/*#__PURE__*/
React.createElement("path", {
  d: "M94.6925 23.5869H95.2454V25.1833H96.1231V25.6602H95.2454V29.475H94.6925V25.6602H93.9393V25.1833H94.6925V23.5869Z",
  fill: "inherit",
  stroke: "none"
});

var _ref19 =
/*#__PURE__*/
React.createElement("path", {
  d: "M102.515 23.5246V24.0637C102.315 23.9738 102.142 23.9324 101.997 23.9324C101.886 23.9324 101.797 23.9531 101.728 23.9946C101.658 24.036 101.61 24.0844 101.596 24.1466C101.575 24.2019 101.569 24.3539 101.569 24.5958V25.1763H102.467V25.6532H101.569V29.468H101.016V25.6532H100.449V25.1763H101.016V24.506C101.016 24.195 101.043 23.9808 101.099 23.8494C101.154 23.7181 101.251 23.6145 101.389 23.5315C101.527 23.4486 101.686 23.4141 101.88 23.4141C102.045 23.4141 102.26 23.4486 102.515 23.5246Z",
  fill: "inherit",
  stroke: "none"
});

var _ref20 =
/*#__PURE__*/
React.createElement("path", {
  d: "M103.759 23.5247H104.312V29.4749H103.759V23.5247Z",
  fill: "inherit",
  stroke: "none"
});

var _ref21 =
/*#__PURE__*/
React.createElement("path", {
  d: "M107.802 25.0728C108.466 25.0728 109.012 25.3146 109.447 25.7915C109.841 26.2269 110.041 26.7452 110.041 27.3395C110.041 27.9408 109.834 28.466 109.413 28.9083C108.998 29.3575 108.459 29.5786 107.802 29.5786C107.146 29.5786 106.607 29.3575 106.185 28.9083C105.771 28.4591 105.556 27.9338 105.556 27.3395C105.556 26.7452 105.757 26.2269 106.151 25.7915C106.593 25.3146 107.139 25.0728 107.802 25.0728ZM107.802 25.6118C107.346 25.6118 106.945 25.7846 106.621 26.1232C106.289 26.4618 106.123 26.8696 106.123 27.3533C106.123 27.6643 106.199 27.9546 106.351 28.2241C106.503 28.4936 106.703 28.701 106.959 28.8461C107.215 28.9912 107.498 29.0672 107.802 29.0672C108.106 29.0672 108.39 28.9912 108.645 28.8461C108.901 28.701 109.102 28.4936 109.254 28.2241C109.406 27.9546 109.482 27.6643 109.482 27.3533C109.482 26.8696 109.316 26.4618 108.984 26.1232C108.652 25.7777 108.258 25.6118 107.802 25.6118Z",
  fill: "inherit",
  stroke: "none"
});

var _ref22 =
/*#__PURE__*/
React.createElement("path", {
  d: "M110.47 25.1833H111.036L112.349 28.3001L113.718 25.1833H113.815L115.19 28.3001L116.531 25.1833H117.104L115.238 29.475H115.135L113.759 26.3997L112.391 29.475H112.287L110.47 25.1833Z",
  fill: "inherit",
  stroke: "none"
});

var _ref23 =
/*#__PURE__*/
React.createElement("path", {
  d: "M3.02671 12.3015V12.8129C2.95069 12.8613 2.85394 12.8958 2.75027 12.8958H2.55677C2.59132 13.1101 2.62588 13.3312 2.66043 13.5524C2.70881 13.8841 2.75718 14.2089 2.79865 14.5337C2.77792 15.4667 2.75027 16.4065 2.72954 17.3395C2.7641 17.4985 2.80556 17.7818 2.72954 18.1135C2.68808 18.307 2.61897 18.4591 2.55677 18.5696H2.59824C2.8332 18.5696 3.02671 18.7217 3.02671 18.9083C3.02671 19.0949 2.8332 19.2469 2.59824 19.2469H2.55677C2.42546 19.2469 2.30107 19.24 2.16976 19.2262C0.946542 19.0672 -0.000244141 18.231 -0.000244141 17.2289V14.2365C-0.000244141 13.2276 0.946542 12.3914 2.16976 12.2462C2.29416 12.2324 2.42546 12.2255 2.54986 12.2255H2.74336C2.85394 12.2186 2.95069 12.2531 3.02671 12.3015Z",
  fill: "inherit",
  stroke: "none"
});

var _ref24 =
/*#__PURE__*/
React.createElement("path", {
  d: "M34.4295 14.2298V17.2222C34.4295 18.3348 33.2823 19.2333 31.8725 19.2333H31.6306C31.3957 19.2333 31.2021 19.0812 31.2021 18.8946C31.2021 18.8739 31.2021 18.8532 31.2091 18.8393C31.2436 18.6804 31.4164 18.5629 31.6306 18.5629H31.8725C31.831 18.3556 31.7896 18.1344 31.7619 17.8995C31.7343 17.6783 31.7066 17.471 31.6928 17.2706V15.0937C31.6721 14.6375 31.6859 14.1192 31.7619 13.5525C31.7896 13.3245 31.831 13.1033 31.8725 12.896H31.4786C31.3749 12.896 31.2782 12.8684 31.2021 12.8131V12.3017C31.2782 12.2533 31.3749 12.2188 31.4786 12.2188H31.8725C31.9347 12.2188 31.9969 12.2187 32.0591 12.2257C33.386 12.3017 34.4295 13.1724 34.4295 14.2298Z",
  fill: "inherit",
  stroke: "none"
});

var _ref25 =
/*#__PURE__*/
React.createElement("path", {
  d: "M32.0594 12.2254C32.0524 11.7071 32.0041 11.1819 31.9004 10.6774C31.2784 7.50532 28.9564 5.49427 25.8396 4.63732C22.9992 3.8564 20.0621 3.45557 17.1181 3.45557C17.0766 3.45557 17.0282 3.45557 16.9868 3.45557C14.0773 3.46939 11.1817 3.87022 8.36895 4.64423C4.74075 5.64631 2.20446 8.47975 2.17682 12.2462C2.17682 12.2669 2.17682 12.2876 2.17682 12.3084V19.4749C2.17682 21.797 3.64192 23.8771 5.82575 24.6511C7.73315 25.3284 9.32956 25.8329 11.3061 26.1577C11.8036 26.2406 12.2321 26.3443 12.7228 26.4825C13.0476 26.5724 13.4346 26.6691 13.8907 26.7659C14.0289 26.7935 14.1741 26.8281 14.333 26.8626C14.8582 26.9732 15.5079 27.0976 16.3579 27.2496C17.36 27.4293 18.3966 26.9179 18.3828 26.0886C18.3759 25.2731 17.3531 24.7617 16.3579 24.9276C15.2522 25.1142 14.8168 25.2317 14.2224 25.3146C14.2155 25.3146 13.7871 25.3837 13.7801 25.3906C12.8334 25.515 12.011 25.4252 11.0642 25.2593C9.26045 24.9414 7.83681 24.4715 6.09527 23.8495C4.25699 23.193 3.01994 21.4376 3.01994 19.4749V12.3015C3.01994 8.89441 5.30744 6.37195 8.58318 5.46662C11.3268 4.71334 14.1464 4.31942 16.9799 4.31251C19.8963 4.29178 22.7919 4.6857 25.6115 5.46662C28.4104 6.23373 30.4975 7.996 31.0573 10.8433C31.154 11.3201 31.2024 11.8108 31.2024 12.3015V15.439C31.2024 15.4804 31.2024 15.5219 31.2024 15.5634V18.7769C31.2024 18.8046 31.2024 18.8253 31.2093 18.846C31.2784 19.3229 32.0179 19.3229 32.0524 18.8046C32.0594 18.7009 32.0594 18.5972 32.0594 18.4936V12.3015C32.0663 12.2807 32.0663 12.2531 32.0594 12.2254Z",
  fill: "inherit",
  stroke: "none"
});

var _ref26 =
/*#__PURE__*/
React.createElement("path", {
  d: "M23.3655 15.577C23.1305 15.577 22.937 15.3834 22.937 15.1485C22.937 14.4367 22.3634 13.8631 21.6516 13.8631C20.9398 13.8631 20.3662 14.4367 20.3662 15.1485C20.3662 15.3834 20.1727 15.577 19.9377 15.577C19.7027 15.577 19.5092 15.3834 19.5092 15.1485C19.5092 13.9667 20.4698 13.0061 21.6516 13.0061C22.8333 13.0061 23.7939 13.9667 23.7939 15.1485C23.7939 15.3904 23.6074 15.577 23.3655 15.577Z",
  fill: "inherit",
  stroke: "none"
});

var _ref27 =
/*#__PURE__*/
React.createElement("path", {
  d: "M14.8028 15.577C14.5678 15.577 14.3743 15.3834 14.3743 15.1485C14.3743 14.4367 13.8007 13.8631 13.0889 13.8631C12.3771 13.8631 11.8035 14.4367 11.8035 15.1485C11.8035 15.3834 11.61 15.577 11.375 15.577C11.14 15.577 10.9465 15.3834 10.9465 15.1485C10.9465 13.9667 11.9071 13.0061 13.0889 13.0061C14.2707 13.0061 15.2313 13.9667 15.2313 15.1485C15.2313 15.3904 15.0378 15.577 14.8028 15.577Z",
  fill: "inherit",
  stroke: "none"
});

var _ref28 =
/*#__PURE__*/
React.createElement("path", {
  d: "M17.18 19.6891C15.7149 19.6891 14.4571 19.2192 13.9734 18.4935C13.8421 18.3 13.8973 18.0305 14.0908 17.8992C14.2843 17.7679 14.5539 17.8232 14.6852 18.0167C14.9547 18.4244 15.9015 18.8322 17.18 18.8322C18.417 18.8322 19.3016 18.459 19.6195 18.0858C19.7716 17.9061 20.048 17.8854 20.2208 18.0443C20.4005 18.1964 20.4212 18.4728 20.2622 18.6456C19.7094 19.2952 18.5276 19.6891 17.18 19.6891Z",
  fill: "inherit",
  stroke: "none"
});

var _ref29 =
/*#__PURE__*/
React.createElement("path", {
  d: "M23.4966 26.9109C23.3722 26.9109 23.2478 26.8694 23.1373 26.7934L18.2858 23.3172C18.2789 23.3103 18.2651 23.3034 18.2582 23.2965C17.9956 23.0685 17.657 22.9441 17.3114 22.9441H12.5498C10.5111 22.9441 8.58992 22.1493 7.14555 20.7049C5.70118 19.2606 4.90643 17.3463 4.90643 15.3076C4.90643 13.255 5.70809 11.3338 7.15937 9.88946C8.60374 8.45891 10.5111 7.67108 12.5429 7.67108C12.5567 7.67108 12.5775 7.67108 12.5913 7.67108C15.5491 7.69181 18.5139 7.69181 21.4026 7.67108C23.4552 7.65726 25.3833 8.44509 26.8346 9.88946C28.2858 11.3338 29.0875 13.262 29.0875 15.3076V17.5398C29.0875 20.5183 26.6618 22.9441 23.6832 22.9441C23.6348 22.9441 23.6003 22.9717 23.5865 22.9855C23.5726 22.9993 23.5519 23.0339 23.5588 23.0823L24.091 26.1922C24.1324 26.4409 24.0218 26.6828 23.8145 26.8141C23.7178 26.8763 23.6072 26.9109 23.4966 26.9109ZM18.7834 22.6469L23.1925 25.8051L22.7503 23.2067C22.7503 23.1998 22.7503 23.1998 22.7503 23.1928C22.7088 22.9164 22.7917 22.64 22.9714 22.4327C23.1511 22.2253 23.4137 22.1009 23.6901 22.1009C26.2126 22.1009 28.2651 20.0484 28.2651 17.526V15.2937C28.2651 13.4693 27.5533 11.7485 26.2541 10.4631C24.9686 9.18455 23.2686 8.48656 21.4579 8.48656C21.4441 8.48656 21.4303 8.48656 21.4095 8.48656C18.5208 8.50729 15.5561 8.50729 12.5913 8.48656C12.5775 8.48656 12.5637 8.48656 12.5498 8.48656C10.7392 8.48656 9.03912 9.19146 7.7537 10.4631C6.45446 11.7623 5.73574 13.4762 5.73574 15.3076C5.73574 17.1251 6.44064 18.839 7.73297 20.1244C9.0253 21.4098 10.7323 22.1217 12.5498 22.1217H17.3114C17.8505 22.1148 18.3688 22.3013 18.7834 22.6469Z",
  fill: "inherit",
  stroke: "none"
});

var SvgDigitalk = function SvgDigitalk(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 118,
    height: 30,
    viewBox: "0 0 118 30",
    stroke: "none",
    fill: "currentColor",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgDigitalk, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/digitalk.8742f9e5.svg";
export { ForwardRef as ReactComponent };